import React from 'react';
import Select from '../../../../components/input/Select';
import Panel from '../../../../components/outline/Panel';
import Button from '../../../../components/Button';
import CheckBox from '../../../../components/input/CheckBox';
import { addAllItemToSelectList } from '../../../../lib/common';
import './BrandTierHeader.scss';

const BrandTierHeader = (props) => {
  const {
    currentTierList,
    brandTierHeader,
    brandTierList,
    setData,
    multipleTierChange,
    checkIsModified,
    editBrandTierListRequest,
    resetBrandTierInfo,
  } = props;
  const { selectedTier, isUpdateRecommendList } = brandTierHeader;
  const { newList, selectedList } = brandTierList;

  return (
    <Panel className="brand-tier-header">
      <div className="brand-tier-header-section">
        <div className="multiple-tier-change-section">
          <label className="multiple-tier-change-label">티어 일괄 변경</label>

          <Select
            className="multiple-tier-change-select"
            size="large"
            list={addAllItemToSelectList(currentTierList)}
            value={selectedTier}
            onChange={(value) => setData({ path: ['brandTierHeader', 'selectedTier'], value })}
          />

          <Button
            isRadius
            className="multiple-tier-change-button"
            color="primary"
            text="선택건 적용"
            disabled={!(selectedTier && selectedList.length)}
            onClick={() => multipleTierChange()}
          />
        </div>

        {/*변경사항 저장*/}
        <div className="tier-change-save-section">
          <CheckBox
            checked={isUpdateRecommendList}
            text="추천목록 update"
            onChange={(checked) => {
              setData({
                path: ['brandTierHeader', 'isUpdateRecommendList'],
                value: checked,
              });
            }}
          />

          <Button
            color="primary"
            text="저장하기"
            disabled={!checkIsModified()}
            onClick={() => editBrandTierListRequest({ newList, isUpdateRecommendList })}
          />

          <Button text="초기화" onClick={resetBrandTierInfo} />
        </div>
      </div>
    </Panel>
  );
};

export default BrandTierHeader;
